import { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { createPdfBlob, downloadBlob } from "@/lib/pdf";
import { waLink, waNum } from "@/lib/api";
import WaIcon from "@/components/WaIcon";

export default function DocumentShareButton({ filename, title, message, phone = "", lines, testid }) {
  const [sharing, setSharing] = useState(false);

  const fallback = (file, text) => {
    downloadBlob(file, filename);
    const fallbackText = `${text}\n\nFile PDF sudah diunduh. Jika belum ikut terlampir, tekan ikon penjepit kertas di WhatsApp lalu pilih file ${filename} dari folder Unduhan.`;
    const url = phone
      ? waLink(fallbackText, waNum(phone))
      : `https://wa.me/?text=${encodeURIComponent(fallbackText)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    toast.info("PDF diunduh. Lampirkan file dari folder Unduhan jika browser tidak mengirimkannya otomatis.");
  };

  const share = async () => {
    if (sharing) return;
    setSharing(true);
    const text = message || `${title} dari NAWADAH by NDH Official.`;
    const blob = createPdfBlob(lines);
    const file = new File([blob], filename, { type: "application/pdf" });
    try {
      const canShareFiles = Boolean(navigator.share) && (!navigator.canShare || navigator.canShare({ files: [file] }));
      if (canShareFiles) {
        await navigator.share({ title, text, files: [file] });
        toast.success("PDF siap dikirim melalui aplikasi yang dipilih");
      } else {
        fallback(file, text);
      }
    } catch (error) {
      if (error?.name !== "AbortError") fallback(file, text);
    } finally {
      setSharing(false);
    }
  };

  return (
    <button type="button" onClick={share} disabled={sharing} data-testid={testid} className="inline-flex items-center gap-2 rounded-md bg-[#25D366] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#1FB958] disabled:opacity-60">
      {sharing ? <Share2 className="h-4 w-4 animate-pulse" /> : <WaIcon className="h-4 w-4" />}
      {sharing ? "Membuat PDF..." : "Kirim PDF ke WhatsApp"}
    </button>
  );
}
